import styled from "styled-components/macro"
import { StatusContainer } from "./Shared.styled"

export const StyledStatusContainer = styled(StatusContainer)`
  display: flex;
  justify-content: flex-end;
`
